import { safeJsonParse } from '@/modules/storage/helpers';

export function decodeJWT(credential: string) {
  const buffer = Buffer.from(credential.split('.')[1], 'base64');
  return safeJsonParse(buffer.toString(), {});
}
